"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Typography_1 = require("@material-ui/core/Typography");
exports.Text = (_a) => {
    var { variant, className, bold, italic, uppercase, underline, h1, h2, h3, subtitle1, body1 } = _a, props = __rest(_a, ["variant", "className", "bold", "italic", "uppercase", "underline", "h1", "h2", "h3", "subtitle1", "body1"]);
    if (h1 == true) {
        variant = "h1";
    }
    if (h2 == true) {
        variant = "h2";
    }
    if (h3 == true) {
        variant = "h3";
    }
    if (subtitle1 == true) {
        variant = "subtitle1";
    }
    else {
        variant == "body1";
    }
    if (bold === true) {
        bold = "bold";
    }
    else {
        null;
    }
    if (italic === true) {
        italic = "italic";
    }
    else {
        null;
    }
    if (uppercase === true) {
        uppercase = "uppercase";
    }
    else {
        null;
    }
    if (underline === true) {
        underline = "underline";
    }
    else {
        null;
    }
    return (React.createElement(Typography_1.default, Object.assign({ variant: variant, style: {
            fontWeight: bold,
            fontStyle: italic,
            textTransform: uppercase,
            textDecoration: underline
        } }, props)));
};
//# sourceMappingURL=Text.js.map